/**
 * Global quick-add behavior.
 *
 * Opt in by adding `data-spv-quick-add` + `data-variant-id` to any clickable
 * element (typically a <button> inside `snippets/spv-plp-card.liquid` when
 * its `quick_add` param is true). On click we POST that variant ID to
 * `Theme.routes.cart_add_url` and dispatch `cart:update` on `document` —
 * `<cart-items-component>` (`assets/component-cart-items.js`) listens for it
 * and morphs the drawer, and `spv-loading-button.js` resets the spinner.
 *
 * The `data` shape `{ detail: { data: {} } }` is required so the listener's
 * `event.detail.data.sections?.[this.sectionId]` optional chain doesn't throw.
 * Without `sections`, the listener falls back to `sectionRenderer.renderSection`
 * — one extra fetch, no Section-Rendering plumbing needed.
 *
 * TODO: when `data-variant-id` is missing or the product has more than one
 *       available variant, open the variant-picker bottom-sheet (Pencil
 *       J48HGA "Cart Drawer / Upsell / Variants / Open") instead of POSTing.
 */
(function () {
  if (window.__spvQuickAdd) return;
  window.__spvQuickAdd = true;

  function dispatchCartUpdate(resource, variantId) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: resource,
          sourceId: 'spv-quick-add',
          data: {
            source: 'spv-quick-add',
            variantId: String(variantId),
          },
        },
      })
    );
  }

  function dispatchCartError(message) {
    document.dispatchEvent(
      new CustomEvent('cart:error', {
        bubbles: true,
        detail: {
          sourceId: 'spv-quick-add',
          data: { message: message || 'Quick-add failed' },
        },
      })
    );
  }

  async function quickAdd(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) {
      console.error('[spv-quick-add] missing data-variant-id', button);
      dispatchCartError('Missing variant id');
      return;
    }

    var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

    try {
      var body = new URLSearchParams();
      body.set('id', variantId);
      body.set('quantity', '1');

      var response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: body.toString(),
      });

      if (!response.ok) {
        var errorText = await response.text();
        throw new Error('cart/add ' + response.status + ': ' + errorText);
      }

      var resource = await response.json();
      dispatchCartUpdate(resource, variantId);
    } catch (err) {
      console.error('[spv-quick-add]', err);
      dispatchCartError(err && err.message);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('[data-spv-quick-add]');
      if (!button) return;

      // Block the click from bubbling to the parent <a class="spv-plp-card__link">
      // and from triggering form submission if button is inside a form.
      event.preventDefault();
      event.stopPropagation();

      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      // `data-loading-button` (spv-loading-button.js) listens on the same click
      // in the capture phase, so the spinner is already on by the time we POST.
      quickAdd(button);
    },
    false
  );
})();
